/**
 * GenesysCommServiceGateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApiResponse { 
    status?: ApiResponse.StatusEnum;
    readonly success?: boolean;
}
export namespace ApiResponse {
    export type StatusEnum = null | null | null;
    export const StatusEnum = {
        NUMBER_null: null as StatusEnum,
        NUMBER_null2: null as StatusEnum,
        NUMBER_null3: null as StatusEnum
    };
}


